import { SUPPLY_CHAIN_ACTIONS } from "constants/actions";

// Supply Chain Data Actions
export function fetchCaseSupplyChainDetails(caseId) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FETCH_CASE_SUPPLY_CHAIN_DETAILS,
        payload: {
            caseId
        }
    };
}

export function fetchedCaseSupplyChainDetails(caseId, data) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FETCHED_CASE_SUPPLY_CHAIN_DETAILS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedFetchCaseSupplyChainDetails(caseId, error) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FAILED_FETCH_CASE_SUPPLY_CHAIN_DETAILS,
        payload: {
            caseId
        },
        error
    };
}

//Supply Chain Financials Actions
export function fetchCaseSupplyChainFinancials(caseId) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FETCH_CASE_SUPPLY_CHAIN_FINANCIALS,
        payload: {
            caseId
        }
    };
}

export function fetchedCaseSupplyChainFinancials(caseId, data) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FETCHED_CASE_SUPPLY_CHAIN_FINANCIALS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedFetchCaseSupplyChainFinancials(caseId, error) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FAILED_FETCH_CASE_SUPPLY_CHAIN_FINANCIALS,
        payload: {
            caseId
        },
        error
    };
}

export function updateCaseSupplyChainDetails(caseId, data) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.UPDATE_CASE_SUPPLY_CHAIN_DETAILS,
        payload: {
            caseId,
            data
        }
    };
}

export function updatedCaseSupplyChainDetails(caseId, data) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.UPDATED_CASE_SUPPLY_CHAIN_DETAILS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedUpdateCaseSupplyChainDetails(caseId, error) {
    return {
        type: SUPPLY_CHAIN_ACTIONS.FAILED_UPDATE_CASE_SUPPLY_CHAIN_DETAILSIALS,
        payload: {
            caseId
        },
        error
    };
}
